import { render, staticRenderFns } from "./CatalogProductDetailModal.vue?vue&type=template&id=02db1cab&scoped=true&"
import script from "./CatalogProductDetailModal.vue?vue&type=script&lang=js&"
export * from "./CatalogProductDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductDetailModal.vue?vue&type=style&index=0&id=02db1cab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02db1cab",
  null
  
)

export default component.exports